import SpeedometerLeftIcon from '@atlaskit/icon-lab/core/speedometer-left';
import * as React from 'react';

export function SvgSpeedSlow() {
  return <SpeedometerLeftIcon label="" testId="ads-refreshed-icon" />;
}
